import { PhraseInput, Spacer } from "@vericus/cadmus-ui";

import { WorkAttachmentSection } from "@/components/work-attachment-section/work-attachment-section";
import { useAppDispatch, useAppSelector } from "@/data/hooks";
import { selectAnswerSnapshot, setLocalSnapshot } from "@/features/authority";
import { readAnswerBlock } from "@/graphql/selectors";
import { Snapshot } from "@/stores/snapshot";

import * as styles from "./answer-form.css";

interface Props {
  /** Answer block ID */
  answerBlockId: string;
  /** Field identifier */
  identifier: string;
  /** Whether the input is readonly */
  isReadonly?: boolean;
  /** Whether attachment is enabled */
  attachmentEnabled?: boolean;
  /** Whether LDB exam mode is enabled */
  isLdbExamMode?: boolean;
}

/**
 * Answer response section to respond with plain text contents.
 */
export const ShortResponseForm = (props: Props) => {
  const {
    answerBlockId,
    isReadonly = false,
    attachmentEnabled,
    isLdbExamMode,
  } = props;
  const snapshot = useAppSelector((state) =>
    selectAnswerSnapshot(state, answerBlockId)
  );
  const dispatch = useAppDispatch();

  const answerShort = getAnswerShort(snapshot, props.identifier);

  const answerBlock = readAnswerBlock(answerBlockId);

  const setValue = (phrase: string) => {
    const newVersion =
      snapshot?.version === undefined ? 0 : snapshot.version + 1;
    const newSnapshot: Snapshot = {
      version: newVersion,
      answerShort: phrase,
      answerFields: {
        [props.identifier]: [phrase],
      },
    };
    dispatch(setLocalSnapshot({ answerBlockId, snapshot: newSnapshot }));
  };

  return (
    <div className={styles.shortAnswerForm}>
      <div className={styles.shortResponse}>
        <PhraseInput
          placeholder="Write your answer here…"
          charactersLimit={100}
          onChange={(event) => {
            setValue(event.target.value);
          }}
          value={answerShort}
          alertLimit={10}
          disabled={isReadonly}
          aria-disabled={isReadonly}
        />
        <Spacer spacing={24} />
        {attachmentEnabled && props.answerBlockId && (
          <WorkAttachmentSection
            answerBlockId={props.answerBlockId}
            attachments={answerBlock?.blockAttachments || []}
            disabled={props.isReadonly}
            ldbExamMode={isLdbExamMode}
            mode={"minimal"}
          />
        )}
      </div>
    </div>
  );
};

function getAnswerShort(
  snapshot: Snapshot | undefined,
  identifier: string
): string {
  if (snapshot?.answerFields) {
    return snapshot.answerFields[identifier]?.[0] ?? "";
  }
  return snapshot?.answerShort ?? "";
}
